import { t } from "i18next";
import { DataTableData } from "../../../../../components/deprecated/DataTable/DataTable";

import { DataObjectHelper, DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";

export class LifeAtWorkCommentHelper extends DataObjectHelper<DataObjectType> {
  override id = () => "LifeAtWorkCommentHelper";

  getAllDataTableDatas(documents: DataObjectType[]): DataTableData[] {
    return [];
  }
  displayName = () => t("main.lifeatwork_sendComment");

  description = new FirebaseDataStringField<DataObjectType>("description", t("main.comment"), (data) =>
    typeof data.description === "string" ? data.description : ""
  );

  allFields() {
    return [this.description];
  }
}

